import { LitElement, html, css } from 'lit';
import { property, customElement, query } from 'lit/decorators.js';

import {
  Document,
  DocumentType,
  Product,
  RetourOrder,
} from '../../types/types';
import { getQueryParamURL, getSearchParam } from '../../util/list_util';
import '../../elements/langhout-button/langhout-button';
import {
  authenticatedAPICall,
  isSuccessfulAPIResponse,
} from '../../client/api-client';
import '../../elements/langhout-checkbox/langhout-checkbox';

import {
  convertRetourOrderStatusToReadable,
  formatDate,
  formatTime,
  RetourOrderStatusApproved,
  RetourOrderStatusBeingChecked,
  RetourOrderStatusCreated,
  RetourOrderStatusProcessed,
  RetourOrderStatusReadyToCheck,
} from '../../util/util';
import { showNotification, confirmPopup } from '../../LanghoutBetonPortal';
import {
  arrowLeftIcon,
  arrowRightIcon,
  closeIcon,
} from '../../elements/icons/icons';
import { sharedStyles } from '../../elements/shared-styles';

@customElement('langhout-beton-view-retour-order')
export class ViewRetourOrder extends LitElement {
  static styles = [
    sharedStyles,
    css`
      :host {
        font-size: 17px;
        color: var(--text-color-main);
        height: calc(100vh - 84px);
        max-height: calc(100vh - 84px);
        overflow-y: auto;
        background-color: white;
        z-index: 100;
        padding: 10px;
        padding-left: 30px;
        padding-right: 30px;
      }

      :host([disableButtons]) {
        pointer-events: none;
        opacity: 0.7;
      }

      .row {
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-grow: 1;
      }

      .centered {
        justify-content: center;
      }

      .inner-wrapper {
        max-width: 900px;
        flex-grow: 1;
      }

      .green {
        color: var(--primary-color);
      }

      .centered-column {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .wrapper {
        padding-bottom: 400px;
        display: flex;
        flex-direction: row;
        justify-content: center;
      }

      .close-wrapper {
        padding: 5px;
        cursor: pointer;
      }

      .label {
        text-align: left;
        min-width: 180px;
        max-width: 180px;
        font-weight: bold;
        flex-grow: 1;
      }

      .value {
        text-align: right;
        min-width: 100px;
        flex-grow: 1;
        max-width: 300px;
      }

      langhout-button {
        width: 200px;
        min-width: 180px;
        margin-right: 20px;
        margin-top: 20px;
      }

      .comment-space {
        width: 40px;
      }

      .button-row {
        flex-wrap: wrap;
        flex-flow: row wrap;
      }

      .display-props {
        margin-bottom: 10px;
      }

      #comment {
        min-width: 200px;
      }

      .order-details-wrapper {
        padding: 10px;
        border: 2px solid var(--primary-color);
        margin-top: 15px;
        border-radius: 5px;
      }

      .add-comment-wrapper {
        margin-top: 20px;
        display: flex;
        flex-direction: row;
      }

      .comment-input-wrapper {
        margin-top: 20px;
      }

      .centered-column {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .prod-amount {
        text-align: left;
        width: 180px;
        font-weight: bold;
      }

      .prod-name {
        text-align: left;
        min-width: 180px;
        max-width: 250px;
      }

      .amount-units {
        text-align: left;
        min-width: 100px;
        max-width: 250px;
      }

      .product-photo {
        width: auto;
        height: 200px;
        cursor: pointer;
      }

      .add-comment-wrapper {
        margin-top: 20px;
        display: flex;
        flex-direction: row;
      }

      #comment {
        min-width: 200px;
      }

      .comment-input-wrapper {
        margin-top: 20px;
      }

      .comment-wrapper {
        padding: 10px;
        border: 2px solid var(--primary-color);
        margin-top: 15px;
        border-radius: 5px;
      }

      .comment-message {
        text-align: left;
      }

      .comment-user-name,
      .comment-time {
        font-weight: bold;
        color: var(--primary-color);
      }

      .photo-container {
        padding-left: 10px;
        padding-right: 10px;
      }

      #modal {
        position: absolute;
        transform: translateX(-3000px);
        transition-duration: 1s;

        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        width: 80vw;
        height: 100%;
        max-height: calc(100vh - 220px);

        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        z-index: 50;
        overflow: hidden;
        padding-bottom: 20px;
        padding-top: 20px;
        border-radius: 10px;
        background-color: white;
        padding-left: 20px;
        padding-right: 20px;

        border: 2px solid var(--primary-color);
      }

      :host([modalVisible]) #modal {
        transition-duration: 500ms;
        transform: translateX(0px);
      }

      .photo-container-full {
        width: 100%;
        max-width: 700px;
        height: 100%;
        max-height: calc(100% - 40px);

        display: flex;
        align-items: center;
        justify-content: center;
      }

      .product-document-full {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }

      .pdf-thumbnail {
        position: relative;
        cursor: pointer;
      }

      .pdf-thumbnail-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
      }

      .close-wrapper-modal {
        cursor: pointer;
        position: absolute;
        top: 10px;
        right: 10px;
      }

      .next-arrow,
      .prev-arrow {
        cursor: pointer;
      }

      .prod-container {
        border: 2px solid var(--primary-color);
        padding: 5px;
        margin-bottom: 10px;
        border-radius: 5px;
      }
    `,
  ];

  @property({ type: Boolean, reflect: true })
  public modalVisible?: boolean = false;

  @property({ type: Boolean, reflect: true })
  private disableButtons = false;

  @property({ type: Object, reflect: true })
  public currentViewRetourOrder: RetourOrder = <RetourOrder>{
    products: <Product[]>[],
  };

  @property({ type: Object, reflect: true })
  public allDocuments: Document[] = [];

  @query('#comment')
  public commentInput?: HTMLInputElement;

  @query('#documentUploadInput')
  private documentUploadInput?: HTMLInputElement;

  private currentID = '';

  @property({ type: Object, reflect: true })
  private selectedDocument: string = '';

  constructor() {
    super();
    this.currentID = getSearchParam(getQueryParamURL(), 'id');
    this.getRetourOrder();
    document.addEventListener(
      'confirm_retour_order_deletion',
      this.removeRetourOrderCall,
    );
    document.addEventListener(
      'confirm_retour_order_processed',
      this.callRetourOrderProcessed,
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(
      'confirm_retour_order_deletion',
      this.removeRetourOrderCall,
    );
    document.removeEventListener(
      'confirm_retour_order_processed',
      this.callRetourOrderProcessed,
    );
  }

  render() {
    return html`
      <div id="modal">
        <div
          class="close-wrapper-modal"
          @click="${() => {
            this.modalVisible = false;
            this.selectedDocument = '';
          }}"
        >
          ${closeIcon()}
        </div>
        <div
          class="prev-arrow"
          @click="${() => {
            this.selectedDocument = this.previousDocumentID();
          }}"
        >
          ${arrowLeftIcon()}
        </div>
        <div class="fill"></div>
        <div class="photo-container-full">
          ${this.renderDocumentContent(this.selectedDocument)}
        </div>
        <div class="fill"></div>

        <div
          class="next-arrow"
          @click="${() => {
            this.selectedDocument = this.nextDocumentID();
          }}"
        >
          ${arrowRightIcon()}
        </div>
      </div>
      <div class="row">
        <div class="fill"></div>
        <div
          class="close-wrapper"
          @click="${() => {
            window.location.href = '/retour-orders';
          }}"
        >
          ${closeIcon()}
        </div>
      </div>
      <div class="wrapper">
        <div class="inner-wrapper">
          <div class="row centered">
            <h2>Retour</h2>
          </div>
          <div class="row centered">
            <div class="label">Status:</div>
            <div class="fill"></div>
            ${this.renderStatus()}
          </div>
          ${this.renderCheckedByUser()}
          <div class="row centered">
            <div class="label">Datum:</div>
            <div class="fill"></div>
            <div class="value">
              ${formatDate(this.currentViewRetourOrder.retour_date)}
            </div>
          </div>
          <div class="order-details-wrapper">
            <div class="row">
              <h3>Order</h3>
            </div>
            <div class="row centered">
              <div class="label">Klantnaam:</div>
              <div class="fill"></div>
              <div class="value">
                ${this.currentViewRetourOrder.customer_name}
              </div>
            </div>
            <div class="row centered">
              <div class="label">Vracht ID:</div>
              <div class="fill"></div>
              <div class="value">
                ${this.currentViewRetourOrder.shipping_id}
              </div>
            </div>
            <div class="row centered">
              <div class="label">Kenteken:</div>
              <div class="fill"></div>
              <div class="value">
                ${this.currentViewRetourOrder.license_plate}
              </div>
            </div>
            <div class="row centered">
              <div class="label">Transporteur:</div>
              <div class="fill"></div>
              <div class="value">
                ${this.currentViewRetourOrder.transporter}
              </div>
            </div>
            ${
              this.currentViewRetourOrder.documents &&
              this.currentViewRetourOrder.documents.length > 0
                ? html`
                    <div class="row">
                      <h3>Documenten</h3>
                    </div>
                    <div class="row centered">
                      ${this.currentViewRetourOrder.documents.map(document => {
                        if (document.type === DocumentType.PDF) {
                          return html`
                            <div
                              class="photo-container pdf-thumbnail"
                              @click="${() => {
                              this.selectedDocument = document.id;
                              this.modalVisible = true;
                            }}"
                            >
                              <div class="pdf-thumbnail-overlay"></div>
                              <iframe
                                src="data:application/pdf;base64, ${document.document}"
                                width="200"
                                height="200"
                              ></iframe>
                            </div>
                          `;
                        }
                        return html`
                          <div
                            class="photo-container"
                            @click="${() => {
                            this.selectedDocument = document.id;
                            this.modalVisible = true;
                          }}"
                          >
                            <img
                              src="data:image/png;base64, ${document.document}"
                              alt="retour document"
                              class="product-photo"
                            />
                          </div>
                        `;
                      })}
                    </div>
                  `
                : ''
            }
            <div class="row">
              <h3>Producten</h3>
            </div>
            ${this.currentViewRetourOrder.products.map(product => {
              return html`
                <div class="prod-container">
                  <div class="row centered display-props prod-row">
                    <div class="prod-amount">
                      ${product.amount} st.
                      ${this.getAmountText(
                        product.amount_packs,
                        product.product_type,
                      )}
                    </div>
                    <div class="amount-units">
                      ${
                        Math.round(
                          (product.amount / product.pieces_per_unit) * 1000,
                        ) / 1000
                      }
                      ${product.unit}
                    </div>
                    <div class="prod-name">${product.description}</div>
                    <div class="fill"></div>
                    <div class="prod-weight">
                      <div>
                        ${this.getWeightText(product.amount, product.weight)}
                      </div>
                    </div>
                  </div>
                  <div class="row centered">
                    ${product.documents.map(document => {
                      if (document.type === DocumentType.PDF) {
                        return html`
                          <div
                            class="photo-container pdf-thumbnail"
                            @click="${() => {
                              this.selectedDocument = document.id;
                              this.modalVisible = true;
                            }}"
                          >
                            <div class="pdf-thumbnail-overlay"></div>
                            <iframe
                              src="data:application/pdf;base64, ${document.document}"
                              width="200"
                              height="200"
                            ></iframe>
                          </div>
                        `;
                      }
                      return html`
                        <div
                          class="photo-container"
                          @click="${() => {
                            this.selectedDocument = document.id;
                            this.modalVisible = true;
                          }}"
                        >
                          <img
                            src="data:image/png;base64, ${document.document}"
                            alt="product document"
                            class="product-photo"
                          />
                        </div>
                      `;
                    })}
                  </div>
                </div>
              `;
            })}
            <div class="row">
              <div>Totaal gewicht:</div>
              <div class="fill"></div>
              ${this.getWeightTotalText(this.currentViewRetourOrder.products)}
            </div>
          </div>
          ${this.renderComments()}
          <div class="add-comment-wrapper button-row centered">
            <div class="centered-column comment-input-wrapper">
              <input
                type="text"
                placeholder="Opmerking"
                id="comment"
                name="comment"
                @keypress=${(e: KeyboardEvent) => {
                  if (e.key === 'Enter') {
                    this.addComment();
                  }
                }}
              />
            </div>
            <div class="comment-space"></div>
            <langhout-button
              id="commentButton"
              text="Opmerking plaatsen"
              @click="${() => {
                const message = this.commentInput
                  ? this.commentInput.value
                  : '';
                if (message === '') {
                  showNotification('Opmerking kan niet leeg zijn');
                  return;
                }
                this.addComment();
              }}"
            >
            </langhout-button>
          </div>
          <div class="row centered display-props">
            ${this.renderProcessedButton(this.currentViewRetourOrder)}
            ${this.renderRemoveButton(this.currentViewRetourOrder)}
            <langhout-button
              text="Wijzigen"
              reverse
              @click="${() => {
                window.location.href =
                  '/update-retour-order?id=' + this.currentID;
              }}"
            ></langhout-button>
            <input
              type="file"
              id="documentUploadInput"
              accept=".png,.jpg,.jpeg,.pdf"
              @change="${this.handleDocumentUpload}"
              style="display:none"
            />
            <langhout-button
              text="Document uploaden"
              reverse
              @click="${() => this.documentUploadInput?.click()}"
            ></langhout-button>
          </div>
          ${this.renderHistory()}
        </div>
      </div>
    `;
  }

  renderStatus = () => {
    if (this.currentViewRetourOrder.status === RetourOrderStatusProcessed) {
      return html` <div class="value green">
        ${convertRetourOrderStatusToReadable(
          this.currentViewRetourOrder.status,
        )}
      </div>`;
    }
    return html` <div class="value">
      ${convertRetourOrderStatusToReadable(this.currentViewRetourOrder.status)}
    </div>`;
  };

  renderProcessedButton = (retourOrder: RetourOrder) => {
    if (retourOrder.status === RetourOrderStatusApproved) {
      return html`
        <langhout-button
          text="Verwerken"
          @click="${() => {
            confirmPopup({
              confirm_event: 'confirm_retour_order_processed',
              title: 'Verwerken bevestigen',
              description:
                'Zijn de benodigde aanpassingen in Exact doorgevoerd? Zo ja klik bevestigen.',
              with_checkbox: false,
              checkbox_text: '',
            });
          }}"
        >
        </langhout-button>
      `;
    }
    return html``;
  };

  renderRemoveButton = (retourOrder: RetourOrder) => {
    if (
      retourOrder.status === RetourOrderStatusCreated ||
      retourOrder.status === RetourOrderStatusReadyToCheck ||
      retourOrder.status === RetourOrderStatusBeingChecked ||
      retourOrder.status === RetourOrderStatusApproved
    ) {
      return html`
        <langhout-button
          text="Verwijderen"
          removeButton
          @click="${() => {
            confirmPopup({
              confirm_event: 'confirm_retour_order_deletion',
              title: 'Verwijderen bevestigen',
              description:
                'Weet u zeker dat u de retour order wilt verwijderen? Deze actie kan niet ongedaan gemaakt worden!',
              with_checkbox: false,
              checkbox_text: '',
            });
          }}"
        >
        </langhout-button>
      `;
    }
    return html``;
  };

  renderComments = () => {
    if (
      !this.currentViewRetourOrder.comments ||
      this.currentViewRetourOrder.comments.length === 0
    ) {
      return html``;
    }
    return html`
      <div class="row">
        <h3>Opmerkingen</h3>
      </div>
      ${this.currentViewRetourOrder.comments.map(comment => {
        return html`
          <div class="comment-wrapper">
            <div class="row">
              <div class="comment-user-name">${comment.user_name}</div>
              <div class="fill"></div>
              <div class="comment-time">
                ${formatTime(comment.timestamp, false)}
              </div>
            </div>
            <div class="row comment-message">${comment.message}</div>
          </div>
        `;
      })}
    `;
  };

  addComment = async () => {
    this.disableButtons = true;
    const message = this.commentInput ? this.commentInput.value : '';
    if (message === '') {
      this.disableButtons = false;
      showNotification('Opmerking kan niet leeg zijn');
      return;
    }
    await this.addCommentCall(this.currentViewRetourOrder, message);
    this.disableButtons = false;
  };

  addCommentCall = async (retourorder: RetourOrder, message: string) => {
    const commentPayload = {
      message: message,
      type: 'portal',
    };
    const path = `/retour-orders/${retourorder.id}/comment`;
    const result = await authenticatedAPICall(
      path,
      'POST',
      new Headers(),
      JSON.stringify(commentPayload),
    );

    if (isSuccessfulAPIResponse(result) && result.body.success) {
      showNotification('Opmerking toegevoegd');
      if (this.commentInput) {
        this.commentInput.value = '';
      }
      this.getRetourOrder();
    }
  };

  renderCheckedByUser = () => {
    if (
      !this.currentViewRetourOrder.checked_user_name ||
      this.currentViewRetourOrder.checked_user_name === ''
    ) {
      return html``;
    }
    return html`
      <div class="row centered">
        <div class="label">Gecontroleerd door:</div>
        <div class="fill"></div>
        <div class="value">
          ${this.currentViewRetourOrder.checked_user_name}
        </div>
      </div>
    `;
  };

  renderHistory = () => {
    if (
      !this.currentViewRetourOrder.history ||
      this.currentViewRetourOrder.history.length === 0
    ) {
      return html``;
    }
    return html`
      <div class="row">
        <h3>Retour order geschiedenis</h3>
      </div>
      ${this.currentViewRetourOrder.history.map(history => {
        return html`
          <div class="comment-wrapper">
            <div class="row">
              <div class="comment-user-name">${history.user_name}</div>
              <div class="fill"></div>
              <div class="comment-time">
                ${formatTime(history.timestamp, false)}
              </div>
            </div>
            <div class="row comment-message">
              ${convertRetourOrderStatusToReadable(history.status)}
            </div>
          </div>
        `;
      })}
    `;
  };

  getWeightTotalText = (products: Product[]): string => {
    let totalWeight = 0;
    products.forEach((p: Product) => {
      totalWeight += p.amount * p.weight;
    });
    return `${Math.ceil(totalWeight).toLocaleString('nl-NL')} kg`;
  };

  getWeightText = (amount: number, weight: number): string => {
    const weightTotal = amount * weight;
    return `${weightTotal.toLocaleString('nl-NL')} kg`;
  };

  getAmountText = (amount: number, type: number): string => {
    if (type === 2) {
      return '';
    }
    if (amount === 1) {
      return `(${amount} pak)`;
    }
    return `(${amount} pakken)`;
  };

  renderDocumentContent = (id: string) => {
    const document = this.allDocuments.find(p => p.id === id);
    if (document) {
      if (document.type === DocumentType.PDF) {
        return html`
          <iframe
            src="data:application/pdf;base64, ${document.document}"
            width="100%"
            height="100%"
            style="min-height: 70vh"
          ></iframe>
        `;
      }
      return html`
        <img
          src="data:image/png;base64, ${document.document}"
          alt="product document"
          class="product-document-full"
        />
      `;
    }
    return html``;
  };

  nextDocumentID = (): string => {
    const currentIndex = this.allDocuments.findIndex(
      p => p.id === this.selectedDocument,
    );
    if (currentIndex < this.allDocuments.length - 1) {
      return this.allDocuments[currentIndex + 1].id;
    } else {
      return this.allDocuments[0].id; // Loop back to the first document
    }
  };

  previousDocumentID = (): string => {
    const currentIndex = this.allDocuments.findIndex(
      p => p.id === this.selectedDocument,
    );
    if (currentIndex > 0) {
      return this.allDocuments[currentIndex - 1].id;
    } else {
      return this.allDocuments[this.allDocuments.length - 1].id; // Loop back to the last document
    }
  };

  getRetourOrder = async () => {
    if (this.currentID === '') {
      return;
    }
    const result = await authenticatedAPICall(
      `/retour-orders/${this.currentID}`,
      'GET',
      new Headers(),
    );
    if (isSuccessfulAPIResponse(result)) {
      this.currentViewRetourOrder = result.body;
      const documents: Document[] = [];
      if (
        this.currentViewRetourOrder.documents &&
        this.currentViewRetourOrder.documents.length > 0
      ) {
        this.currentViewRetourOrder.documents.forEach(document => {
          documents.push(document);
        });
      }
      for (let i = 0; i < this.currentViewRetourOrder.products.length; i++) {
        const product = this.currentViewRetourOrder.products[i];
        if (product.documents && product.documents.length > 0) {
          product.documents.forEach(document => {
            documents.push(document);
          });
        }
      }
      this.allDocuments = documents;
    }
  };

  removeRetourOrderCall = async () => {
    const path = `/retour-orders/${this.currentViewRetourOrder.id}`;
    const result = await authenticatedAPICall(path, 'DELETE', new Headers());
    if (!isSuccessfulAPIResponse(result)) {
      return;
    }
    if (!result.body.success) {
      showNotification(
        'De retour order kon niet worden verwijderd, probeer het later opnieuw',
      );
    } else {
      window.location.href = '/retour-orders';
    }
  };

  callRetourOrderProcessed = async () => {
    const path = `/retour-orders/${this.currentViewRetourOrder.id}/status`;
    const result = await authenticatedAPICall(
      path,
      'PUT',
      new Headers(),
      JSON.stringify({
        status: RetourOrderStatusProcessed,
      }),
    );
    if (!isSuccessfulAPIResponse(result)) {
      return;
    }
    if (!result.body.success) {
      showNotification(
        'De retour order kon niet worden aangepast naar verwerkt',
      );
    } else {
      this.getRetourOrder();
    }
  };

  handleDocumentUpload = async (e: Event) => {
    const input = e.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;
    this.disableButtons = true;
    const file = input.files[0];
    const base64 = await this.fileToBase64(file);
    const path = `/retour-orders/${this.currentID}/document-upload`;
    const result = await authenticatedAPICall(
      path,
      'POST',
      new Headers(),
      JSON.stringify({
        type: file.type,
        document: base64,
      }),
    );
    input.value = '';
    this.disableButtons = false;
    if (isSuccessfulAPIResponse(result) && result.body.success) {
      showNotification('Document geüpload');
      this.getRetourOrder();
    } else {
      showNotification('Document uploaden mislukt');
    }
  };

  private fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        resolve(result.split(',')[1]);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };
}

declare global {
  interface HTMLElementTagNameMap {
    'langhout-beton-view-retour-order': ViewRetourOrder;
  }
}
